module.exports = __webpack_public_path__ + "img/default-header.efe6ac2f.png";